/**
 * ScanDataGraph is resonsible for rendering a graph of a scan of THz, Infrared, etc.
 */
import { Line, LineChart, ReferenceLine, Tooltip, XAxis, YAxis } from "recharts"
import { useEffect, useState } from "react";
import { Dict } from "../../../../types/types";
import { ScanDataGraphProps } from "./ScanDataGraph.types";

const ScanDataGraph = (props: ScanDataGraphProps) => {
  
  const {
    scanData,
    invertScanData,
    dataKeys,
    width,
    dataMapper,
    min,
    max
  } = props

  /**
   * Data to display on graph.
   */
  const [graphData, setGraphData] = useState<Dict[]>([])

  /**
   * Available graph line colours.
   */
  const GRAPH_LINE_COLOURS = ["#C9349C", "#6ADCF2", "#8884d8", "#FFA500"]

  /**
   * Duration in ms of graph line animations.
   */
  const GRAPH_ANIMATION_DURATION = 300

  /**
   * Padding from max and min data values to top and bottom of graph respectively.
   */
  const GRAPH_DATA_PADDING = 0.02

  useEffect(() => {  
    const graphDataObjects = []
    const scanDataCopy = [...scanData]
    if (invertScanData) {
      scanDataCopy.reverse()
    }
    for (let column=0; column<scanDataCopy[0].length; column++) {

      const dataObj = Object.fromEntries(
        dataKeys.map((key, i) => [key, dataMapper ? dataMapper(scanDataCopy[i][column]) : scanDataCopy[i][column]])
      )
      graphDataObjects.push({
        ...dataObj,
        amt: column
      })
    }
    setGraphData(graphDataObjects)
  }, [scanData, invertScanData])

  /**
   * Gets line colour for data key. Will duplicate/loop colours when given data key index is greater
   * than available colours.
   * 
   * @param i index of data key
   * 
   * @returns valid line colour
   */
  const getGraphLineColour = (i: number) => {
    return GRAPH_LINE_COLOURS[i % GRAPH_LINE_COLOURS.length]
  }

  return (
    <LineChart
      width={width}
      height={200}
      data={graphData}
      margin={{
        top: 0,
        right: 0,
        left: 1,
        bottom: 0,
      }}
    >
      <XAxis dataKey="name"/>
      <ReferenceLine y={0} stroke="var(--outline)" />
      <YAxis domain={[min-(GRAPH_DATA_PADDING * max), max+GRAPH_DATA_PADDING * max]} tick={false} axisLine={false} width={0} />
      <Tooltip />
      {dataKeys.map((dataKey, key) => (
        <Line 
          key={key}
          // animationDuration={GRAPH_ANIMATION_DURATION}
          isAnimationActive={false}
          type="monotone"
          dataKey={dataKey}
          stroke={getGraphLineColour(key)}
          dot={false}
        />
      ))}
    </LineChart>
  )
}

export default ScanDataGraph